import { Injectable } from '@angular/core';
import { appLocalForage } from './local-forage.instance';

@Injectable()
export class LocalStorageService {

    getItem(key: string, callback: any): void {
        if (!appLocalForage) {
            return;
        }

        appLocalForage.getItem(key, callback);
    }


    setItem(key, value, callback?: any): void {
        if (!appLocalForage) {
            return;
        }

        if (value === null) {
            value = undefined;
        }

        appLocalForage.setItem(key, value, callback);
    }
}
